export const WORDS_1 = [
  'would',
  'price',
  'email',
  'music',
  'video',
  'years',
  'group',
  'could',
  'hotel',
  'store',
  'terms',
  'forum',
  'black',
  'index',
  'women',
  'today',
  'pages',
  'power',
  'think',
  'media',
  'water',
  'since',
  'guide',
  'board',
  'white',
  'money',
  'reply',
  'value',
  'learn',
  'print',
  'stock',
  'point',
  'large',
  'study',
  'party',
  'login',
  'quote',
  'story',
  'young',
  'range',
  'audio',
  'light',
  'might',
  'month',
  'space',
  'cards',
  'child',
  'share',
  'radio',
  'short',
  'beach',
  'front',
  'sound',
  'rules',
  'final',
  'watch',
  'words',
  'quick',
  'basic',
  'views',
  'plans',
  'woman',
  'cable',
  'score',
  'ideas',
  'cause',
  'focus',
  'thank',
  'earth',
  'extra',
  'rated',
  'bring',
  'valid',
  'metal',
  'funds',
  'match',
  'plant',
  'break',
  'block',
  'hands',
  'coast',
  'stand',
  'chief',
  'stone',
  'phase',
  'crime',
  'claim',
  'drugs',
  'prime',
  'louis',
  'tours',
  'labor',
  'magic',
  'mount',
  'latin',
  'virus',
  'facts',
  'moved',
  'films',
  'tried',
  'laser',
  'dream',
  'eight',
  'judge',
  'fight',
  'bonus',
  'parks',
  'angel',
  'sharp',
  'logic',
  'fruit',
  'sugar',
  'exact',
  'novel',
  'plays',
  'broad',
  'yours',
  'doubt',
  'split',
  'marks',
  'rapid',
  'plane',
  'trips',
  'giant',
  'worst',
  'quiet',
  'picks',
  'prize',
  'fraud',
  'mayor',
  'diary',
  'quest',
  'acres',
  'smile',
  'moral',
  'bread',
  'fault',
  'blade',
  'meals',
  'liked',
  'adopt',
  'nodes',
  'chase',
  'rocky',
  'grain',
  'brush',
  'macro',
  'burns',
  'blast',
  'tears',
  'organ',
  'paste',
  'pixel',
  'paths',
  'tanks',
  'herbs',
  'tires',
  'handy',
  'crops',
  'medal',
  'tumor',
  'disco',
  'lyric',
  'hired',
  'merit',
  'drain',
  'beats',
  'scuba',
  'fears',
  'viral',
  'yacht',
  'belts',
  'flush',
  'ruled',
  'purse',
  'oxide',
  'grams',
  'wagon',
  'resin',
  'lords',
  'blunt',
  'freak',
  'hydro',
  'clamp',
  'grasp',
  'roast',
  'comet',
  'prose',
  'clues',
  'fetch',
  'unite',
  'mates',
  'lungs',
  'quasi',
  'faint',
  'quark',
  'mound',
  'exits',
  'aisle',
  'flirt',
  'cider',
  'tread',
  'snowy',
  'sutra',
  'clans',
  'taxed',
  'shrub',
  'ethyl',
  'slant',
  'right',
  'topic',
  'forms',
  'youth',
  'frame',
  'fresh',
  'solid',
  'draft',
  'ocean',
  'depth',
  'route',
  'drink',
  'cream',
  'slide',
  'pilot',
  'yield',
  'pound',
  'crowd',
  'juice',
  'slave',
  'lemon',
  'fairy',
  'token',
  'sedan',
  'demon',
  'cobra',
  'ankle',
  'noisy',
  'clash',
  'tempo',
  'shiny',
  'slept',
  'crank',
  'cured',
  'venom',
  'husky',
  'wiped',
  'slump', // Sep 1st
  'first', // Sep 2nd
  'filed', // Sep 3rd
  'fired', // Sep 4th
  'drove', // Sep 5th
  'awful', // Sep 6th
  'spite', // Sep 7th
  'nicer', // Sep 8th
  'spear', // Sep 9th
  'flock', // Sep 10th
  'owing', // Sep 11th
  'waltz', // Sep 12th
  'snail', // Sep 13th
  'axiom', // Sep 14th
  'smack', // Sep 15th
  'drown', // Sep 16th
  'infer', // Sep 17th
  'lingo', // Sep 18th
  'braid', // Sep 19th
  'vixen', // Sep 20th
  'shred', // Sep 21st
  'wiser', // Sep 22nd
  'flung', // Sep 23rd
  'guise', // Sep 24th
  'rabid', // Sep 25th
  'nosed', // Sep 26th
  'islet', // Sep 27th
  'brash', // Sep 28th
  'snark', // Sep 29th
  'wield', // Sep 30th
  'clung', // Oct 1st
  'hound', // Oct 2nd
  'drive', // Oct 3rd
  'cited', // Oct 4th
  'grown', // Oct 5th
  'crypt', // Oct 6th
  'hairy', // Oct 7th
  'unity', // Oct 8th
  'death', // Oct 9th
  'mason', // Oct 10th
  'optic', // Oct 11th
  'float', // Oct 12th
  'boxer', // Oct 13th
  'covey', // Oct 14th
  'sixty', // Oct 15th
  'shade', // Oct 16th
  'stack', // Oct 17th
  'paint', // Oct 18th
  'amber', // Oct 19th
  'trope', // Oct 20th
  'swirl', // Oct 21th
  'voice', // Oct 22nd
  'melon', // Oct 23rd
  'sonar', // Oct 24th
  'prick', // Oct 25th
  'taken', // Oct 26th
  'dance', // Oct 27th
  'sixty', // Oct 28th
  'punch', // Oct 29th
  'ratio', // Oct 30th
  'crash', // Oct 31st
  'steam', // Nov 1st
  'wheat', // Nov 2nd
  'lower', // Nov 3rd
  'guard', // Nov 4th
  'strip', // Nov 5th
  'tuple', // Nov 6th
  'poked', // Nov 7th
]

export const WORDS_2 = [
  'might',
  'funds',
  'proxy',
  'banjo',
  'flash',
  'month',
  'niche',
  'might',
  'cabin',
  'build',
  'valid',
  'pages',
  'white',
  'graph',
  'girls',
  'since',
  'forum',
  'gains',
  'argue',
  'focus',
  'fluid',
  'today',
  'watch',
  'chief',
  'black',
  'fraud',
  'admit',
  'point',
  'touch',
  'flash',
  'brand',
  'value',
  'thick',
  'logic',
  'blocs',
  'query',
  'diary',
  'fable',
  'frail',
  'shift',
  'bytes',
  'waves',
  'would',
  'years',
  'orbit',
  'phone',
  'woman',
  'imply',
  'guest',
  'quick',
  'mount',
  'backs',
  'pitch',
  'match',
  'score',
  'spend',
  'latin',
  'delay',
  'model',
  'dogma',
  'tried',
  'child',
  'ports',
  'album',
  'humor',
  'imply',
  'trend',
  'yours',
  'cloud',
  'bonus',
  'shown',
  'steal',
  'zeros',
  'cords',
  'price',
  'round',
  'squid',
  'fight',
  'shaft',
  'mercy',
  'ridge',
  'climb',
  'mayor',
  'brick',
  'orbit',
  'tough',
  'doubt',
  'toxic',
  'count',
  'henry',
  'famed',
  'funds',
  'quest',
  'ridge',
  'codex',
  'clone',
  'humor',
  'swung',
  'debut',
  'plans',
  'optic',
  'ghost',
  'psalm',
  'trial',
  'break',
  'track',
  'hotel',
  'witch',
  'knife',
  'parse',
  'honey',
  'honey',
  'minus',
  'diary',
  'wrote',
  'niche',
  'thank',
  'claim',
  'foray',
  'vowel',
  'shock',
  'orbit',
  'beach',
  'ducks',
  'final',
  'angry',
  'threw',
  'locus',
  'money',
  'chief',
  'novel',
  'glory',
  'width',
  'agony',
  'ethic',
  'spicy',
  'noise',
  'stick',
  'broth',
  'wants',
  'unify',
  'lymph',
  'robin',
  'dunes',
  'cloth',
  'paint',
  'typed',
  'thief',
  'drone',
  'dying',
  'flute',
  'flour',
  'stack',
  'fibre',
  'rifle',
  'fungi',
  'pylon',
  'servo',
  'wheat',
  'scout',
  'gland',
  'funky',
  'tunes',
  'flown',
  'goals',
  'flows',
  'vinyl',
  'flyer',
  'guilt',
  'fetus',
  'rides',
  'pouch',
  'brine',
  'kings',
  'manly',
  'butyl',
  'ounce',
  'truck',
  'chalk',
  'junta',
  'screw',
  'slimy',
  'fuels',
  'knobs',
  'untie',
  'chewy',
  'lunar',
  'haiku',
  'brain',
  'grabs',
  'clasp',
  'pinky',
  'vapor',
  'crony',
  'rough',
  'helix',
  'caves',
  'plumb',
  'trunk',
  'amuse',
  'salty',
  'cling',
  'cedar',
  'yogic',
  'tribe',
  'suing',
  'leafy',
  'acids',
  'vigor',
  'flank',
  'vague',
  'phyla',
  'pride',
  'input',
  'candy',
  'wafer',
  'bench',
  'drift',
  'focal',
  'basin',
  'sauce',
  'dough',
  'thumb',
  'squad',
  'spark',
  'liter',
  'sneak',
  'vodka',
  'dowry',
  'gravy',
  'golem',
  'glyph',
  'turbo',
  'wrath',
  'spiny',
  'wrist',
  'gated',
  'rowdy',
  'swing',
  'glaze',
  'drank',
  'setup',
  'toxin',
  'scaly',
  'corgi',
  'burnt',
  'hover', // Sep 1st 
  'newly', // Sep 2nd 
  'sworn', // Sep 3rd 
  'blown', // Sep 4th 
  'snuck', // Sep 5th 
  'dirty', // Sep 6th
  'favor', // Sep 7th
  'plush', // Sep 8th
  'tunic', // Sep 9th
  'haunt', // Sep 10th
  'cater', // Sep 11th
  'remix', // Sep 12th
  'gumbo', // Sep 13th
  'curve', // Sep 14th
  'whirl', // Sep 15th
  'blaze', // Sep 16th
  'boast', // Sep 17th
  'expat', // Sep 18th
  'coset', // Sep 19th
  'stork', // Sep 20th
  'bloat', // Sep 21st
  'godly', // Sep 22nd
  'crept', // Sep 23rd
  'apron', // Sep 24th
  'stung', // Sep 25th
  'curly', // Sep 26th
  'fjord', // Sep 27th
  'pokey', // Sep 28th
  'itchy', // Sep 29th
  'crush', // Sep 30th
  'waive', // Oct 1st
  'zebra', // Oct 2nd
  'shaft', // Oct 3rd
  'shown', // Oct 4th
  'lived', // Oct 5th
  'lodge', // Oct 6th
  'nosed', // Oct 7th
  'whole', // Oct 8th
  'glory', // Oct 9th
  'clerk', // Oct 10th
  'relay', // Oct 11th
  'weigh', // Oct 12th
  'squad', // Oct 13th
  'quail', // Oct 14th
  'dozen', // Oct 15th
  'motif', // Oct 16th
  'fixed', // Oct 17th
  'smoke', // Oct 18th
  'cloth', // Oct 19th
  'slang', // Oct 20th
  'donut', // Oct 21th
  'drums', // Oct 22nd
  'spiky', // Oct 23rd
  'glide', // Oct 24th
  'shout', // Oct 25th
  'porch', // Oct 26th
  'sport', // Oct 27th
  'older', // Oct 28th
  'alert', // Oct 29th
  'pulse', // Oct 30th
  'pilot', // Oct 31st
  'pylon', // Nov 1st
  'opium', // Nov 2nd
  'pitch', // Nov 3rd
  'bench', // Nov 4th
  'globe', // Nov 5th
  'sigma', // Nov 6th
  'laugh', // Nov 7th
]
